<template>
  <div id="AqtSpin" :style="{bottom:bottom,height:height,top:top}">
<!--    <img class="spin_img" src="@/assets/images/gif/bookgif_1.gif">-->
    <Spin fix></Spin>
  </div>
</template>

<script>
export default {
  props:{
    bottom:{
      type:[String],
      default:'0px'
    },
    top:{
      type:[String],
      default:'0px'
    },
    height:{
      type:[String,Number],
      default:'100%'
    },
  },
  data(){
    return{

    }
  },
  methods:{

  },
  created() {
  }
}
</script>

<style lang="less" scoped>
#AqtSpin{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999999999;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .spin_img{
    width: 300px;
    height: auto;
  }
}
</style>
